<template>
  <v-container fluid class="grey lighten-4">
    <!-- content -->
    <v-container class="container--max">
      <v-row align="center" justify="center">
        <v-col cols="12" class="d-flex flex-no-wrap align-center">
          <!-- <div class="text-uppercase white--text px-4">Multimedia</div> -->
          <v-spacer class="d-flex d-sm-none"></v-spacer>
          <v-btn href="/video" text small color="accent">Video<v-icon>mdi-chevron-right</v-icon></v-btn>
          <v-btn href="/audio" text small color="accent">Audio<v-icon>mdi-chevron-right</v-icon></v-btn>
          <!-- icons -->
          <v-spacer class="d-none d-sm-flex"></v-spacer>
          <div class="text-uppercase white--text d-none d-sm-flex">
<!--             <v-btn icon dark href="/audio" aria-label="Audio">
              <v-icon color="white">mdi-podcast</v-icon>
            </v-btn>
            <v-btn icon dark href="/video" aria-label="Video">
              <v-icon color="white">mdi-play-circle-outline</v-icon>
            </v-btn> -->
            <v-btn href="https://www.youtube.com/channel/UCbxXu42P7hiExin_nfG5XQw" target="_blank" rel="noopener" icon color="accent" class="mb-1">
              <v-icon>mdi-youtube</v-icon>
            </v-btn>
            <v-btn href="https://podcasts.apple.com/gb/podcast/the-moggcast/id1335312124" target="_blank" rel="noopener" icon color="accent" class="mb-1">
              <v-icon>mdi-podcast</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <!-- carousel for mobile -->
      <v-row class="d-flex d-md-none">
        <v-carousel hide-delimiters height="auto">
          <v-carousel-item v-for="(item, i) in items" :key="i">
            <media-card
              :post="item"
              transparent 
              fill-height
            ></media-card>
          </v-carousel-item>
        </v-carousel>
      </v-row>
      <!-- row for desktop -->
      <v-row style="min-height: 288px;" class="d-none d-md-flex">
        <v-col cols="12" sm="6" md="4" lg="3" v-for="(item, i) in items" :key="i" :class="i == 2 ? 'd-md-none d-lg-block' : ''">
          <media-card
            :post="item"
            transparent 
            fill-height
          ></media-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
  export default {
    name: 'HomeMedia',

    props: {
      excludedIds: {
        type: Array,
        default: () => ([])
      }
    },

    data: () => ({
      items: []
    }),

    methods: {
      getMediaPosts() {
        this.$axios.get('/wp-json/wp/v2/posts?exclude=' + this.excludedIds + '&categories=118,430,10590,75&filter[orderby]=date&order=desc&per_page=4') // 29,40,270
        .then(response => { // 160,43,
          this.items = response.data
        })
      }
    },

    mounted() {
      this.getMediaPosts()
    }
  }
</script>